(function () {
    'use strict';

    angular.module('AngularAdmin')

        .directive('pdOrderPlanner', ['$rootScope', function ($rootScope) {
            return {
                restrict: "E",
                replace: true,
                templateUrl: '/static/partials/order_planner/order_planner.html',
                controller: "OrderPlannerCtrl",
                controllerAs: "order_planner",
                link: function ($scope, $element, $attr) {

                }
            };
        }])

        .directive('pdOrderPlannerEntryTableRowEntry', ['$filter', '$sce', function ($filter, $sce) {
            var numberFilter = $filter('number');

            return {
                restrict: "A",
                templateUrl: '/static/partials/order_planner/order_planner_entry_table_row_entry.html',
                scope: {
                    entry: "=",
                    orderPlanner: "=",
                    materialPlan: "="
                },
                replace: true,
                //controller: "OrderPlannerCtrl",
                //controllerAs: "order_planner",
                link: function ($scope, $element, $attr) {

                    $scope.displayFn = function (estimate) {
                        var estimate = estimate.estimate;
                        var html = "";
                        if(!$scope.entry)
                            return $sce.trustAsHtml("");

                        if($scope.entry.hasEstimates) {
                            var parsed_input = numberFilter(estimate.parsed_input, 0);
                            if($scope.orderPlanner.selected_table_view == 'price') {
                                var calculated_revenue = numberFilter(estimate.calculated_revenue, 0);
                                html = `$<span>${calculated_revenue}</span>`;
                                if($scope.orderPlanner.show_quantities) {
                                    html += `<br /> <span class="text-muted">(${parsed_input})</span>`;
                                }
                            } else {
                                html = parsed_input;
                            }
                        } else {
                            var percent = numberFilter($scope.orderPlanner.plan.sales_distribution.estimates[this.$index].percentage, 0);
                            html = `<span class="text-muted">${percent}%</span>`;
                        }

                        return $sce.trustAsHtml(html);
                    }
                }
            };
        }])

        .directive('pdOrderPlannerEntryTableRowSummary', ['$filter', '$sce', function ($filter, $sce) {
            var numberFilter = $filter('number');

            return {
                restrict: "A",
                templateUrl: '/static/partials/order_planner/order_planner_entry_table_row_summary.html',
                scope: {
                    entry: "=",
                    orderPlanner: "=",
                    materialPlan: "="
                },
                replace: true,
                //controller: "OrderPlannerCtrl",
                //controllerAs: "order_planner",
                link: function ($scope, $element, $attr) {
                    $scope.displayFn = function (month) {
                        var month = month.month;
                        var html = "";
                        if(!$scope.entry) {
                            // Do nothing
                        } else if($scope.orderPlanner.selected_table_view == 'price') {
                            var calculated_revenue = numberFilter(month.scheduled_revenue, 0);
                            html = `$${calculated_revenue}`;
                        } else {
                            var scheduled = numberFilter(month.scheduled, 0);
                            html = `${scheduled}`;
                        }

                        return $sce.trustAsHtml(html);
                    }
                }
            };
        }])

        .directive('pdOrderPlannerEntryTableRowFixedEntry', ['$rootScope', function ($rootScope) {
            return {
                restrict: "A",
                templateUrl: '/static/partials/order_planner/order_planner_entry_table_row_fixed_entry.html',
                scope: false,
                replace: true,
                //controller: "OrderPlannerCtrl",
                //controllerAs: "order_planner",
                link: function ($scope, $element, $attr) {
                    if($attr.isVarious=="") {
                        $scope.$watch('material_plan.various', function (various) {
                            $scope.entry = various;
                        });
                        $scope.entry = $scope.material_plan.various;
                    }
                }
            };
        }])

        .directive('pdOrderPlannerEntryTableRowFixedSummary', ['$rootScope', function ($rootScope) {
            return {
                restrict: "A",
                templateUrl: '/static/partials/order_planner/order_planner_entry_table_row_fixed_summary.html',
                scope: false,
                replace: true,
                //controller: "OrderPlannerCtrl",
                //controllerAs: "order_planner",
                link: function ($scope, $element, $attr) {
                    if($attr.isVarious=="") {
                        $scope.$watch('material_plan.various', function (various) {
                            $scope.entry = various
                        });
                        $scope.entry = $scope.material_plan.various;
                    }
                }
            };
        }])
})();